import { Component } from '@angular/core';

@Component({
  selector: 'app-horizontal-page-menu',
  templateUrl: './horizontal-page-menu.component.html',
  styleUrls: ['./horizontal-page-menu.component.scss'],
})
export class HorizontalPageMenuComponent {
}
